import {BackendStatsOrders} from 'components/Backend/Stats/Orders';

export default BackendStatsOrders;
export const orderNum = 6;
export const title = '財務統計報表';
